import React from "react";
import VitrineSeguroViagem from "../../../components/Vitrine/VitrineSeguroViagem";

function VitrineSeguro() {
  return <VitrineSeguroViagem />;
}

export default VitrineSeguro;
